export function getUrlLocale () {
  const FIRST_IN_SLASHES = new RegExp('/(.*?)(?=/)') // Each string wrapped by "/"
  const urlLocale = window.location.pathname.match(FIRST_IN_SLASHES)[0].replace('/', '') // Returning the first match only as we need the local
  return (urlLocale.length === 2) ? urlLocale : null
}

// Source: https://davidwalsh.name/query-string-javascript
export function getUrlParameter (name) {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]')
  var regex = new RegExp('[\\?&]' + name + '=([^&]*)')
  var results = regex.exec(window.location.href)
  return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '))
}
